export default __webpack_public_path__ + "static/media/right.9b1e554a.png";